<template>
  <div class="view-blog container-fluid py-5">
    <h3 class="mb-4">Bolsas e oportunidades</h3>
    <div class="row">
      <div class="col-lg-9">
        <form @submit.prevent="search" class="d-flex align-items-center">
          <form-group
            id="search"
            class="flex-fill mb-0"
            v-model="parameters.search"
            placeholder="Pesquisar"
          />
          <button type="submit" class="btn btn-primary rounded-pill ml-2">
            <i class="icon-search lead"></i>
          </button>
        </form>

        <action-dispatcher
          action="blog/getArticles"
          :parameters="parameters"
          ref="actionDispatcher"
        >
          <div class="mt-3 text-secondary" v-html="count" />
          <initial-layout
            v-if="isInitial"
            :articles="articles"
            @open-article="openArticle"
          />
          <div v-else class="row">
            <article-link
              v-for="(article, index) in articles"
              :key="index"
              :article="article"
              class="col-lg-4 py-4"
              @open-article="openArticle"
            />
          </div>
          <div class="row">
            <div class="col-12">
              <pagination
                :parameters="parameters"
                :articles="articles"
                @next="nextPage"
              />
            </div>
          </div>
        </action-dispatcher>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h5 class="mb-0">Filtrar resultados</h5>
              <button
                class="border-0 bg-transparent text-secondary font-weight-bold"
                @click="clearFilter"
              >
                Limpar
              </button>
            </div>
            <hr />
            <filters
              v-model="parameters.status"
              :items="[
                { id: 'enable', name: 'Abertas' },
                { id: 'disable', name: 'Fechadas' }
              ]"
              @input="search"
              unique
            />
            <hr />
            <action-dispatcher action="blog/getLevels">
              <div class="mb-2">Nível:</div>
              <filters
                v-model="parameters.level__in"
                :items="levels"
                @input="search"
              />
            </action-dispatcher>
            <hr />
            <action-dispatcher action="blog/getLocations">
              <div class="mb-2">Localização:</div>
              <filters
                v-model="parameters.location__in"
                :items="locations"
                @input="search"
              />
            </action-dispatcher>
            <hr />
            <action-dispatcher action="blog/getSubjects">
              <div class="mb-2">Área:</div>
              <filters
                v-model="parameters.subject__in"
                :items="subjects"
                @input="search"
              />
            </action-dispatcher>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleLink from "../components/blog/ArticleLink";
import Filters from "../components/blog/Filters";
import Pagination from "../components/blog/Pagination";
import InitialLayout from "../components/blog/InitialLayout";
import { mapState } from "vuex";
import get from "lodash/get";

export default {
  components: { ArticleLink, Filters, Pagination, InitialLayout },
  data() {
    return {
      parameters: {
        limit: 9,
        offset: 0,
        level__in: "",
        subject__in: "",
        status: "",
        location__in: "",
        search: ""
      }
    };
  },
  computed: {
    ...mapState("blog", [
      "articles",
      "locations",
      "subjects",
      "levels",
      "pagination"
    ]),
    count() {
      const count = get(this.pagination, "count", 0);
      return `${count} resultado${count != 1 ? "s" : ""} encontrado${
        count != 1 ? "s" : ""
      }`;
    },
    isInitial() {
      return (
        this.parameters.level__in === "" &&
        this.parameters.subject__in === "" &&
        this.parameters.status === "" &&
        this.parameters.location__in === "" &&
        this.parameters.search === "" &&
        this.parameters.limit == 9
      );
    }
  },
  methods: {
    clearFilter() {
      this.parameters.level__in = "";
      this.parameters.subject__in = "";
      this.parameters.status = "";
      this.parameters.location__in = "";
      this.search();
    },
    search() {
      this.parameters.offset = 0;
      this.parameters.limit = 9;
      this.$refs.actionDispatcher.dispatch();
    },
    //Caso cliente queira voltar a paginação antiga remover esses cometanrios abaixo
    // prevPage() {
    //   this.parameters.offset -= this.parameters.limit;
    //   this.$refs.actionDispatcher.dispatch();
    // },
    nextPage() {
      this.parameters.limit += 3;
      //Caso cliente queira voltar a paginação antiga remover  codigos acima e habilitar codigo comentado
      //this.parameters.offset += this.parameters.limit;
      this.$refs.actionDispatcher.dispatch();
      if (this.parameters.limit == 12) {
        window.scrollTo(0, 0);
      }
    },
    openArticle(article) {
      this.$router.push({
        name: "blog-article",
        params: { id: article.id, slug: article.slug }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-blog {
  .card {
    background: rgba(0, 0, 0, 0.2);
    border-color: white;
    border-radius: 6px;
  }

  hr {
    border-color: rgba(255, 255, 255, 0.7);
  }

  ::v-deep .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: unset;
  }
}
</style>
